import React from 'react'
import { toTitleCase } from '@/utils/string'
import { match } from 'ts-pattern'
import { ArrowDownIcon, ArrowRightIcon, ArrowUpIcon } from 'lucide-react'
import { Text } from '@/components'
import NumberFlow from '@number-flow/react'
import { CostCategoryLabel } from '@/types/thermostatCostCategoryControls'

export const getCostCategoryDisplayElements = ({
  minValue,
  maxValue,
  type,
}: {
  type: CostCategoryLabel
  minValue: number
  maxValue: number
}) => {
  const title = `${toTitleCase(type)} Cost Hour`
  const icon = match(type)
    .with('negative', () => (
      <ArrowDownIcon size={18} className="text-base-green-900" />
    ))
    .with('low', () => (
      <ArrowDownIcon size={18} className="text-base-green-700" />
    ))
    .with('medium', () => (
      <ArrowRightIcon size={18} className="text-base-orange-500" />
    ))
    .with('high', () => <ArrowUpIcon size={18} className="text-base-red-500" />)
    .exhaustive()
  const description = match(type)
    .with('negative', () => (
      <Text variant="h3" className="text-sm text-base-green-900">
        {'<0¢ per kWh'}
      </Text>
    ))
    .with('low', () => (
      <Text variant="h3" className="text-sm text-base-green-700">
        {'0-'}
        <NumberFlow value={maxValue - 1} />
        {`¢ per kWh`}
      </Text>
    ))
    .with('medium', () => (
      <Text variant="h3" className="text-sm text-base-orange-500">
        <NumberFlow value={minValue} />
        {'-'}
        <NumberFlow value={maxValue} />
        {`¢ per kWh`}
      </Text>
    ))
    .with('high', () => (
      <Text variant="h3" className="text-sm text-base-red-500">
        {'>'}
        <NumberFlow value={minValue} />
        {'¢ per kWh'}
      </Text>
    ))
    .exhaustive()
  return { title, icon, description }
}
